import React from 'react';

/** Totals for the price-list KPI cards. */
export function usePriceAnalytics(prices) {
    return React.useMemo(() => {
        const totalLists = prices?.length || 0;
        const activeLists = prices?.filter((p) => p.active)?.length || 0;
        const inactiveLists = totalLists - activeLists;

        // Count by channel
        const moderno = prices?.filter((p) => p.channel === 'MODERNO')?.length || 0;
        const tradicional = prices?.filter((p) => p.channel === 'TRADICIONAL')?.length || 0;

        return { totalLists, activeLists, inactiveLists, moderno, tradicional };
    }, [prices]);
}

/** Search-as-you-type over the price lists (by name), with autocomplete suggestions. */
export function usePriceSearch({ setRows, prices }) {
    const [searchValue, setSearchValue] = React.useState('');
    const [suggestions, setSuggestions] = React.useState([]);

    const onSearch = (search) => {
        try {
            setSearchValue(search);
            if (!search || typeof search !== 'string') {
                setSuggestions([]);
                setRows(prices || []);
                return;
            }

            const filteredData = prices?.filter((c) => c.type && c.type.toLowerCase().includes(search.toLowerCase())) || [];
            setSuggestions(filteredData.map((c) => c.type));
            setRows(filteredData);
        } catch (error) {
            console.warn('Error in price search:', error);
            setRows(prices || []);
        }
    };

    return { searchValue, setSearchValue, suggestions, onSearch };
}
